import Text from "../../../design-system/primitives/components/Text/Text";
import Button from "../../../design-system/primitives/components/Button/Button";
import Checkbox from "../../../design-system/primitives/components/Checkbox/Checkbox";
import type { HandbookChecklistItem } from "../../../api/handbook";
import HandbookColumn from "./HandbookColumn";
import styles from "./HandbookWelcome.css";

type HandbookWelcomeProps = {
  onShowDocuments: () => void;
  checklist: HandbookChecklistItem[];
  checked: Record<string, boolean>;
  onCheckedChange: (key: string, checked: boolean) => void;
};

const HandbookWelcome = ({
  onShowDocuments,
  checklist,
  checked,
  onCheckedChange,
}: HandbookWelcomeProps) => (
  <HandbookColumn>
    <div className={styles.intro}>
      <Text variant="h4">Hi!</Text>
      <Text color="neutral-100">
        Schön, dass du die Sparks nutzt. Die Informationen auf dieser Seite
        helfen dir, dich noch besser zurechtzufinden.
      </Text>
    </div>

    <div className={styles.checklist}>
      <Text variant="subheader">Checkliste</Text>

      <div className={styles.items}>
        {checklist.map((item) => (
          <Checkbox
            key={item.key}
            label={item.text}
            checked={checked[item.key] ?? false}
            onCheckedChange={(value) =>
              onCheckedChange(item.key, value === true)
            }
          />
        ))}
      </div>
    </div>

    <div className={styles.promo}>
      <div className={styles.cardText}>
        <div className={styles.badge}>
          <Text variant="label-small" color="inherit" uppercase>
            Neu
          </Text>
        </div>
        <Text variant="subheader">Moderationspläne</Text>
        <Text>Zum Ausdrucken! Check unsere neuen Moderationspläne!</Text>
      </div>

      <Button
        title="Anschauen"
        iconRight="arrow-right"
        onClick={onShowDocuments}
      />
    </div>
  </HandbookColumn>
);

export default HandbookWelcome;
